import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { SprayEventForSubmission } from 'services/sprayEventsForSubmission/types';
import { selectApplicationTypeDisplay } from './selectors';

export interface Props {
    sprayEventId: SprayEventForSubmission['id'];
}

export default function RenderSubmissionSprayEventsTableRowApplicationTypeCell(
    props: Props
): React.ReactElement {
    const applicationType = useSelector((state: AppState) =>
        selectApplicationTypeDisplay(state, props)
    );

    return (
        <TableCell textAlign="left" className="events-table-cell-padding">
            {applicationType}
        </TableCell>
    );
}
